"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useMousetrap = void 0;
var _mousetrap = _interopRequireDefault(require("mousetrap"));
var _react = require("react");
// istanbul ignore file @preserve -- copied from lib
/** Binds a specified keyboard command to a callback method (https://craig.is/killing/mice) */ const useMousetrap = (keys, callback, action)=>{
    const callbackRef = (0, _react.useRef)(callback);
    (0, _react.useEffect)(()=>{
        if (keys !== null) {
            _mousetrap.default.bind(keys, (event, combo)=>{
                if (typeof callbackRef.current === 'function') {
                    callbackRef.current(event, combo);
                }
            }, action);
        }
        return ()=>{
            if (keys !== null) {
                _mousetrap.default.unbind(keys);
            }
        };
    }, [
        keys,
        action
    ]);
};
exports.useMousetrap = useMousetrap;
